import { useEffect, useState } from "react";
import { Card } from "../../ui/Card";
import { PageHeader } from "./shared";

type Outlet = {
  outletId: string;
  outletName: string;
  timeZone?: string;
  status?: string;
  logoURL?: string;
};
type Session = { ok: boolean; outlets?: Outlet[] };

/**
 * Outlets page — full list from session, rendered as a real table.
 * Zero upstream calls needed; the outlet[] array comes back in the
 * login response and lives on the signed cookie.
 */
export function Outlets() {
  const [sess, setSess] = useState<Session | null>(null);
  useEffect(() => {
    void fetch("/api/auth/session").then((r) => r.json()).then(setSess).catch(() => {});
  }, []);
  const outlets = sess?.outlets ?? [];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Outlets"
        subtitle={`${outlets.length} outlets connected to your Zeemart account.`}
      />
      <Card>
        {outlets.length === 0 ? (
          <p className="text-ink-mute text-sm">No outlets on this account.</p>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-line text-xs uppercase tracking-wider text-ink-mute">
                <th className="text-left py-2">Outlet</th>
                <th className="text-left py-2">Code</th>
                <th className="text-left py-2">Timezone</th>
                <th className="text-left py-2">Status</th>
              </tr>
            </thead>
            <tbody>
              {outlets.map((o) => (
                <tr key={o.outletId} className="border-b border-line/60 last:border-0 hover:bg-canvas">
                  <td className="py-2 text-ink font-medium">{o.outletName}</td>
                  <td className="py-2 text-ink-2 tabular-nums">{o.outletId}</td>
                  <td className="py-2 text-ink-2">{o.timeZone ?? "—"}</td>
                  <td className="py-2">
                    <span
                      className={
                        "inline-flex items-center gap-1.5 text-xs px-2 py-0.5 rounded-md border " +
                        (o.status === "A"
                          ? "border-good/30 text-good bg-good/10"
                          : "border-line text-ink-mute bg-canvas-2")
                      }
                    >
                      <span aria-hidden className={"w-1.5 h-1.5 rounded-full " + (o.status === "A" ? "bg-good" : "bg-ink-mute")} />
                      {o.status === "A" ? "Active" : (o.status ?? "—")}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
